module.exports = __webpack_public_path__ + "img/znmb.886fa498.png";